import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 17"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M2.82 1.18a1.16 1.16 0 1 0-1.64 1.64zm11.36 14.64a1.16 1.16 0 1 0 1.64-1.64zm1.64-13a1.16 1.16 0 1 0-1.64-1.64zM1.18 14.18a1.16 1.16 0 1 0 1.64 1.64zm0-11.36 13 13 1.64-1.64-13-13zm13-1.64-13 13 1.64 1.64 13-13z"
    }, null, -1)
  ]))]))
}
export default { render: render }